import { render, staticRenderFns } from "./SaleTable.vue?vue&type=template&id=68efad52&scoped=true"
import script from "./SaleTable.vue?vue&type=script&lang=ts"
export * from "./SaleTable.vue?vue&type=script&lang=ts"
import style0 from "./SaleTable.vue?vue&type=style&index=0&id=68efad52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68efad52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68efad52')) {
      api.createRecord('68efad52', component.options)
    } else {
      api.reload('68efad52', component.options)
    }
    module.hot.accept("./SaleTable.vue?vue&type=template&id=68efad52&scoped=true", function () {
      api.rerender('68efad52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/SaleTable.vue"
export default component.exports